const ruleFactory = (message, trigger = ["blur", "change"]) => {
  return { required: true, message, trigger };
};

export default ruleFactory;
